import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { getLang } from '~/commons/helpers';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';
import { env } from '../../config';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload.js'

const api = '/api/core/users/students/stats';

const ListScores = () => {
  const isAdmin = env.user.roles.includes('admin');
  const stage = env?.school?.stage;
  const { t, i18n: { language } } = useTranslation();
  const [canDownloadCert, setCanDownloadCert] = useState(null);
  const lang = language === 'en' ? 'en' : 'zhhk';

  const certDownloadStartDate = new Date(env.certSetting.certificateDownloadStartDate).getTime();
  const certDownloadEndDate = new Date(env.certSetting.certificateDownloadEndDate).getTime() + 24*60*60*1000;
  const now = new Date().getTime();
  const canDownloadCertNow = certDownloadStartDate <= now && now <= certDownloadEndDate;

  useEffect(() => {
    if ( canDownloadCertNow ) {
      axios.get('/api/core/users/students/canExportCertificates')
      .then(({ data }) => {
        setCanDownloadCert(data.success ? true : false);
      }).catch((err) => {
        console.error(err);
        setCanDownloadCert(false);
      });
    } else {
      setCanDownloadCert(false);
    }
  }, []);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          ...(env.user.schoolClass ? [] :[
            { value: 'schoolClass.title', label: 'Class' },
            {
              value: 'schoolClass.grade',
              label: 'Grade',
              options: Object.keys(env.grades)
                .filter((g) => {
                  if (stage === 'p') return g <= 6;
                  if (stage === 's') return g >= 7;
  
                  return true;
                })
                .map((g) => ({
                  value: g,
                  label: env.grades[g][lang],
                })),
            },
          ]),
          { value: 'studentId', label: 'Class No.' },
          ...isAdmin ? [{
            value: 'school.title', label: 'School',
          }] : [],
        ],
        filter: {},
        api,
        sort: { 'score': -1 },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: canDownloadCert ? {
            href: '/api/core/users/students/certificates.zip', 
            target: '_blank',
          } : false,
        },
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => getLang(get(r, 'name.full'), lang),
          },
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => env.lvs[v][lang],
          },
          ...(isAdmin ? [
            {
              key: 'school.title.en',
              children: 'School',
              getter: (v, r) => getLang(get(r, 'school.title'), lang),
            },
          ] : []),
          {
            key: 'schoolClass.acadYear',
            children: 'Year',
            getter: (v)=>(`${v}/${v+1}`)
          },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            sortable: true,
            getter: (v) => env.grades[v][lang],
          },
          {
            key: 'schoolClass.title',
            children: 'Class',
            sortable: true,
          },
          {
            key: 'studentNo',
            children: 'Class No.',
            sortable: true,
            getter: (v, r) => r.studentId,
          },
          {
            key: 'score',
            sortable: true,
            getter: (v, r) => (v || 0),
          },
          {
            key: 'cutOffScore',
            sortable: true,
            getter: (v, r) => (v || 0),
          },
          {
            key: '"assignmentCount"',
            children: 'Total Score',
            sortable: true,
            getter: (v, r) => ((r.assignmentCount||0) * 60),
          },
          {
            key: 'cutOffScore',
            children: 'Awards',
            getter: (v, r) => (
              v >= env.certSetting.copperScore ? ('「閱讀之星」' + (v >= env.certSetting.goldScore ? '金獎' : v >= env.certSetting.silverScore ? '銀獎' : '銅獎' )) : '-'
            ),
          },
          {
            key: 'cutOffScore',
            children: 'Certificate Download',
            getter: (v, r) => (
              v >= env.certSetting.copperScore && canDownloadCertNow
              ? <a href={`/api/core/users/students/${r._id}/certificate`} className="btn btn-primary" target="_blank"><FA icon={faFileDownload} fixedWidth size="lg" />{t('Download')}</a> 
              : <a href="#" className="btn btn-outline-dark disabled" style={{opacity: '0.25'}}><FA icon={faFileDownload} fixedWidth size="lg" />{t('Download')}</a> 
            ),
          },
        ],
      }}
    >
    </ListResource>
  );
};

export default ListScores;
